import { RootState } from "@/app/stores"
import { getUsers, IGetUsersResults } from "@/shared/api/users"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchUsers = createAsyncThunk<
    IGetUsersResults,
    void,
    { state: RootState }
>('users/fetchUsers', async (_, thunkAPI) => {
    try {
        const { usersPage, usersLimit, usersSearch, usersGroup, usersBlockStatus, usersDeletedStatus, usersAttractedStatus } = thunkAPI.getState().users
        const data = await getUsers({
            limit: usersLimit,
            page: usersPage,
            with_balances: true,
            role_id: "users",
            search: usersSearch,
            group_id: usersGroup,
            block_status: usersBlockStatus === 'all' ? undefined : usersBlockStatus,
            deleted_status: usersDeletedStatus === 'active' ? undefined : usersDeletedStatus,
            attracted: usersAttractedStatus === 'all' ? undefined : usersAttractedStatus
        })
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchEmployees = createAsyncThunk<
    IGetUsersResults,
    void,
    { state: RootState }
>('users/fetchEmployees', async (_, thunkAPI) => {
    try {
        const { employeesPage, employeesLimit, employeesSearch, employeesGroup, employeesBlockStatus, employeesDeletedStatus } = thunkAPI.getState().users
        const data = await getUsers({
            limit: employeesLimit,
            page: employeesPage,
            with_balances: true,
            role_id: "employees",
            search: employeesSearch,
            group_id: employeesGroup,
            block_status: employeesBlockStatus === 'all' ? undefined : employeesBlockStatus,
            deleted_status: employeesDeletedStatus === 'active' ? undefined : employeesDeletedStatus
        })
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
